import Vue from 'vue';
import { MutationTree } from 'vuex';
import { ViolationState} from './types';
import * as firebase from 'firebase';
import {MAFViolation} from './types';
import { MAFUser } from '../User/types';
import { Lookup } from '@/store/types';


export const mutations: MutationTree<ViolationState> = {
    setAllUsers(state, payload: MAFUser[] | undefined) {
        if (state) {
            state.allUsers = payload;
        }
    },
    setViolations(state, payload: MAFViolation[] | undefined) {
        if (state) {
            state.violations = payload;
        }
    },
    setResolutions(state, payload: Lookup| undefined) {
        if (state) {
            state.resolutions = payload ? payload : undefined;
        }
    },

};
